import { PrintProductionDto } from '../../../../../../../../model/print-production/print-production-dto';
import { BulkPrice } from '../../../../../../../../model/print-production/bulk-price';

export class ClientOrderStockHelper {
  private static defaultOptions = [
    {
      amount: 10,
      enabled: true,
    },
    {
      amount: 25,
      pricePerUnit: 0,
      enabled: true,
    },
    {
      amount: 50,
      pricePerUnit: 0,
      enabled: true,
    },
    {
      amount: 100,
      pricePerUnit: 0,
      enabled: true,
    },
    {
      amount: 200,
      pricePerUnit: 0,
      enabled: true,
    },
  ];

  static prepareOrderStockOptions(
    printProductionDto?: PrintProductionDto
  ): OrderStockOption[] {
    let stockOptions: OrderStockOption[] = this.defaultOptions;
    if (printProductionDto) {
      this.defaultOptions.forEach((value) => {
        let bulkPrice = this.findPrice(printProductionDto, value.amount);
        if (bulkPrice) {
          value.pricePerUnit = bulkPrice.unitPrice;
        }
      });
    }

    return stockOptions;
  }

  static findPrice(
    printProductionDto: PrintProductionDto,
    bulkNumber: number
  ): BulkPrice | undefined {
    return printProductionDto.bulkPrices?.find(
      (value) => value.bulkNumber === bulkNumber
    );
  }
}

export interface OrderStockOption {
  amount: number;
  pricePerUnit?: number;
  selected?: boolean;
  enabled: boolean;
}
